type Props = {
  email?: string
  name?: string
  fallback?: string
}

export const LoadUserDisplay = ({ email, name, fallback }: Props) => {
  const display = name?.trim() || email?.trim() || fallback?.trim()

  if (!display) {
    return null
  }

  return <>{display}</>
}
